var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6783 8.66667H20.3217C21.395 8.66665 22.2808 8.66664 23.0024 8.72559C23.7519 8.78683 24.4408 8.91824 25.088 9.24797C26.0915 9.75929 26.9074 10.5752 27.4187 11.5787C27.7484 12.2258 27.8798 12.9148 27.9411 13.6642C28 14.3858 28 15.2716 28 16.3449V22.3218C28 23.395 28 24.2808 27.9411 25.0024C27.8798 25.7519 27.7484 26.4408 27.4187 27.0879C26.9074 28.0915 26.0915 28.9074 25.088 29.4187C24.4408 29.7484 23.7519 29.8798 23.0024 29.9411C22.2808 30 21.395 30 20.3217 30H11.6783C10.605 30 9.71917 30 8.99757 29.9411C8.2481 29.8798 7.55917 29.7484 6.91205 29.4187C5.90852 28.9074 5.09262 28.0915 4.5813 27.0879C4.25158 26.4408 4.12016 25.7519 4.05893 25.0024C3.99997 24.2808 3.99998 23.395 4 22.3217V16.3449C3.99998 15.2716 3.99997 14.3858 4.05893 13.6642C4.12016 12.9148 4.25158 12.2258 4.5813 11.5787C5.09262 10.5752 5.90852 9.75929 6.91205 9.24797C7.55917 8.91824 8.2481 8.78683 8.99757 8.72559C9.71916 8.66664 10.605 8.66665 11.6783 8.66667ZM9.21472 11.3834C8.63016 11.4312 8.33123 11.5177 8.12269 11.624C7.62093 11.8796 7.21298 12.2876 6.95732 12.7894C6.85106 12.9979 6.7645 13.2968 6.71674 13.8814C6.6677 14.4815 6.66667 15.2579 6.66667 16.4V22.2667C6.66667 23.4088 6.6677 24.1852 6.71674 24.7853C6.7645 25.3698 6.85106 25.6688 6.95732 25.8773C7.21298 26.3791 7.62093 26.787 8.12269 27.0427C8.33123 27.1489 8.63016 27.2355 9.21472 27.2833C9.81484 27.3323 10.5912 27.3333 11.7333 27.3333H20.2667C21.4088 27.3333 22.1852 27.3323 22.7853 27.2833C23.3698 27.2355 23.6688 27.1489 23.8773 27.0427C24.3791 26.787 24.787 26.3791 25.0427 25.8773C25.1489 25.6688 25.2355 25.3698 25.2833 24.7853C25.3323 24.1852 25.3333 23.4088 25.3333 22.2667V16.4C25.3333 15.2579 25.3323 14.4815 25.2833 13.8814C25.2355 13.2968 25.1489 12.9979 25.0427 12.7894C24.787 12.2876 24.3791 11.8796 23.8773 11.624C23.6688 11.5177 23.3698 11.4312 22.7853 11.3834C22.1852 11.3344 21.4088 11.3333 20.2667 11.3333H11.7333C10.5912 11.3333 9.81484 11.3344 9.21472 11.3834Z",
    fill: "url(#paint0_linear_56188_112)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 5.23999L13.3333 6.00008L10.6667 5.99992L10.6668 4.13068L11.0377 3.74386C11.361 3.40664 11.8434 2.91621 12.6865 2.55038C13.502 2.19659 14.5535 2 16.0001 2C17.4466 2 18.4982 2.1966 19.3136 2.55041C20.1567 2.91624 20.6391 3.40667 20.9624 3.74383L21.3333 4.13069V6H18.6667V5.23998C18.5487 5.14789 18.4193 5.06923 18.2522 4.99672C17.879 4.83482 17.2201 4.66667 16.0001 4.66667C14.78 4.66667 14.1211 4.83481 13.7479 4.99671C13.5808 5.06922 13.4514 5.1479 13.3334 5.23999Z",
    fill: "url(#paint1_linear_56188_112)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 24.6667C14.4129 24.6675 12.7912 24.26 11.2 23.0667L12.8 20.9333C13.8755 21.74 14.9181 22.0006 15.9993 22C17.0805 21.9994 18.1254 21.7393 19.2 20.9333L20.8 23.0667C19.208 24.2607 17.5839 24.6658 16.0007 24.6667Z",
    fill: "url(#paint2_linear_56188_112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 17.3333C9.33333 16.2288 10.2288 15.3333 11.3333 15.3333C12.4379 15.3333 13.3333 16.2288 13.3333 17.3333C13.3333 18.4379 12.4379 19.3333 11.3333 19.3333C10.2288 19.3333 9.33333 18.4379 9.33333 17.3333Z",
    fill: "url(#paint3_linear_56188_112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 17.3333C18.6667 16.2288 19.5621 15.3333 20.6667 15.3333C21.7712 15.3333 22.6667 16.2288 22.6667 17.3333C22.6667 18.4379 21.7712 19.3333 20.6667 19.3333C19.5621 19.3333 18.6667 18.4379 18.6667 17.3333Z",
    fill: "url(#paint4_linear_56188_112)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56188_112",
    x1: 6.36808,
    y1: 34.0756,
    x2: 28.589,
    y2: 12.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56188_112",
    x1: 6.36808,
    y1: 34.0756,
    x2: 28.589,
    y2: 12.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56188_112",
    x1: 6.36808,
    y1: 34.0756,
    x2: 28.589,
    y2: 12.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_56188_112",
    x1: 6.36808,
    y1: 34.0756,
    x2: 28.589,
    y2: 12.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_56188_112",
    x1: 6.36808,
    y1: 34.0756,
    x2: 28.589,
    y2: 12.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.79ae6d5f140e6b52b7e91f0722808967.svg";
export { ForwardRef as ReactComponent };